import React, {FC, useEffect, useState} from 'react';

export interface CarouselSlide {
  alt: string;
  caption: string;
  src: string;
}

interface StepsCarouselProps {
  slides: CarouselSlide[];
}

/** 自动播放间隔（毫秒）：与首页 Counter 等其他动效节奏保持同量级，不过快过慢 */
const AUTO_PLAY_INTERVAL = 4000;

/**
 * 「三步生成」区块右侧轮播图：把原「三种素材输入方式」的两张真实操作截图
 * （粘贴链接/插件采集）与「选择参数」「高清图生成」两步的配图合并进同一个轮播，
 * 取代原来图文并排的独立区块。纯自研（不引入 react-responsive-carousel，
 * 避免其全局 CSS 与 v3 Tailwind 体系冲突），淡入淡出 + 底部圆点手动切换。
 */
const StepsCarousel: FC<StepsCarouselProps> = ({slides}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, AUTO_PLAY_INTERVAL);
    return () => window.clearInterval(timer);
  }, [slides.length]);

  return (
    <div>
      <div className="relative rounded-2xl shadow-xl overflow-hidden aspect-[4/3]">
        {slides.map((slide, index) => (
          <img
            alt={slide.alt}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
              index === activeIndex ? 'opacity-100' : 'opacity-0'
            }`}
            decoding="async"
            key={slide.src}
            loading="lazy"
            src={slide.src}
          />
        ))}
      </div>
      <p className="text-sm text-slate-500 text-center mt-4 min-h-[2.5rem]">{slides[activeIndex].caption}</p>
      <div className="flex justify-center gap-2 mt-2">
        {slides.map((slide, index) => (
          <button
            aria-label={slide.alt}
            className={`h-2 rounded-full transition-all ${
              index === activeIndex ? 'w-6 bg-indigo-600' : 'w-2 bg-slate-300'
            }`}
            key={slide.src}
            onClick={() => setActiveIndex(index)}
            type="button"
          />
        ))}
      </div>
    </div>
  );
};

export default StepsCarousel;
